/**
 * Dashboard Types and Constants
 */

export interface Attempt {
  attempt_id?: number;
  id?: number;
  completed_at?: string;
  version: string;
  percentage: number;
  score?: number;
  total_score?: number;
  max_score: number;
}

export interface DimensionInfo {
  name: string;
  desc: string;
}

export const DIMENSIONS: DimensionInfo[] = [
  { name: "Vitesse d'acquisition", desc: "Apprendre de nouvelles règles" },
  { name: "Rétention", desc: "Mémoriser après distraction" },
  { name: "Transfert", desc: "Appliquer des connaissances" },
  { name: "Adaptabilité", desc: "S'ajuster aux changements" },
  { name: "Feedback", desc: "Corriger des stratégies" },
];

export const CHALLENGE_INFO = {
  duration: "40-48 min",
  questions: 44,
  maxScore: 54,
} as const;
